import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { fetchFeatureList } from "reducers/feature";
import { RootState } from "store/state";

//Component
import {
  DataGrid,
  GridColDef,
  GridColumns,
  GridToolbarContainer,
} from "@material-ui/data-grid";
import CustomLoadingOverlay from "components/DataGridLoadingOverlay";
import CustomNoRowsOverlay from "components/DataGridNoRowsOverlay";
import { ARIA_SuccessCode, Configuration, ConfigurationGroup } from "models";
import { DataGridFilterToolbar } from "components/DataGridFilterToolbar";
import { GridColFilterDef } from "components/DataGridFilterSelection";
//Icon

//Helper
import { convertDateTimeToString } from "utils/dateHelper";
import { Data } from "react-csv/components/CommonPropTypes";
import { ExportButton } from "components/ExportButton";
import { MainDrawer } from "components/MainDrawer";
import { AccessControlButton, FeatureSelector } from "components";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@material-ui/core";
import {
  PM_ADD_CONFIG_GROUP_CODE,
  PM_EDIT_CONFIG_GROUP_CODE,
  PM_DELETE_CONFIG_GROUP_CODE,
} from "models/backend/constant/PermissionCode";
import {
  createConfigurationGroupAPI,
  deleteConfigurationGroupAPI,
  getConfigurationGroupListAPI,
  updateConfigurationGroupAPI,
} from "services/configurationGroupService";

export const ConfigurationGroupManagementScreen = () => {
  const dispatch = useDispatch();

  const { featureList } = useSelector((state: RootState) => state.featureState);

  const [index, setIndex] = useState<number>(1);
  const [size, setSize] = useState<number>(10);
  const [row, setRow] = useState<number>(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isExporting, setIsExporting] = useState(false);

  const [requestDateTime, setRequestDateTime] = useState<Date>(new Date());

  const [
    configurationGroupManagementList,
    setConfigurationGroupManagementList,
  ] = useState<ConfigurationGroup[]>([]);
  const [exportList, setExportList] = useState<Data>([]);
  const [filterList, setFilterList] = useState<GridColFilterDef[]>([]);

  const [loadList, setloadList] = useState(true);

  const [addConfigurationGroup, setAddConfigurationGroup] = useState<
    any | undefined
  >();
  const [editConfigurationGroup, setEditConfigurationGroup] = useState<
    ConfigurationGroup | undefined
  >();
  const [removeConfigurationGroup, setRemoveConfigurationGroup] = useState<
    ConfigurationGroup | undefined
  >();
  const [deleteConfirmation, setDeleteConfirmation] = useState("");
  const [selectedFeatureIds, setSelectedFeatureIds] = useState<number[]>([]);

  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

  //Setting up the each column header item
  const hotelGroupCodeHeader: GridColDef = {
    field: "configurations",
    headerName: "No Of Features",
    sortable: false,
    renderHeader: (params: any) => <strong>{"No of Features"}</strong>,
    valueGetter: (params) => {
      var jsonString = JSON.stringify(params.value);
      var configuration: Configuration[] = JSON.parse(jsonString);

      return configuration.length;
    },
    minWidth: 150,
  };

  const configurationGroupNameHeader: GridColDef = {
    field: "name",
    headerName: "Name",
    sortable: false,
    renderHeader: (params: any) => <strong>{"Name"}</strong>,
    minWidth: 200,
    flex: 1,
  };

  const actionsHeader: GridColDef = {
    field: "id",
    headerName: "Actions",
    minWidth: 240,
    filterable: false,
    sortable: false,
    disableColumnMenu: true,
    renderHeader: () => <strong>{"Actions"}</strong>,
    renderCell: (params: any) => (
      <strong>
        <AccessControlButton
          code={PM_EDIT_CONFIG_GROUP_CODE}
          variant="contained"
          color="primary"
          size="small"
          value={params.value}
          onClick={handleOpenEditDialog}
        >
          Edit
        </AccessControlButton>
        <AccessControlButton
          code={PM_ADD_CONFIG_GROUP_CODE}
          variant="contained"
          color="primary"
          size="small"
          value={params.value}
          style={{ marginLeft: 12 }}
          onClick={handleDuplicateFunctionClick}
        >
          Clone
        </AccessControlButton>
        <AccessControlButton
          code={PM_DELETE_CONFIG_GROUP_CODE}
          variant="contained"
          color="primary"
          size="small"
          value={params.value}
          style={{ marginLeft: 12 }}
          onClick={handleOpenDeleteDialog}
        >
          Delete
        </AccessControlButton>
      </strong>
    ),
  };

  const headerColumn: GridColumns = [
    configurationGroupNameHeader,
    hotelGroupCodeHeader,
    actionsHeader,
  ];

  React.useEffect(() => {
    dispatch(fetchFeatureList());
  }, []);

  React.useEffect(() => {
    if (loadList) {
      setIsLoading(true);
      setConfigurationGroupManagementList([]);
      setRequestDateTime(new Date());

      getConfigurationGroupListAPI({
        filter: filterList,
        pageIndex: index,
        pageSize: size,
        // orderBy: "module",
      })
        .then((response) => {
          if (response.resultCode === ARIA_SuccessCode) {
            setConfigurationGroupManagementList(response.result.items);
            setRow(response.result.rowCount);
          }
        })
        .finally(() => {
          setloadList(false);
          setIsLoading(false);
        });
    }
  }, [index, size, filterList, loadList]);

  const getExportTransaction = async () => {
    setIsLoading(true);
    var _exportIndex = 1;
    var exportList: ConfigurationGroup[] = [];

    try {
      do {
        var response = await getConfigurationGroupListAPI({
          filter: filterList,
          pageIndex: _exportIndex,
          pageSize: size,
          //   orderBy: "module",
        });

        exportList.push(...response.result.items);

        _exportIndex++;
      } while (response.result.pageCount >= _exportIndex);

      setExportList(exportList);
      setIsExporting(true);
      setIsLoading(false);
    } catch (err) {
      console.log("Oposs.. Something is wrong");
    }
  };

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <DataGridFilterToolbar
          headerColumns={headerColumn}
          filterList={filterList}
          onFilterApply={(items) => {
            setFilterList(items.slice());
            setloadList(true);
          }}
        />
        <ExportButton
          filename="ConfigurationGroup"
          data={exportList}
          headers={[{ label: "Name", key: "name" }]}
          readyToExport={isExporting}
          onClick={getExportTransaction}
          onFinishDownload={() => {
            setExportList([]);
            setIsExporting(false);
          }}
        >
          Export
        </ExportButton>
        <div style={{ flexGrow: 1 }}></div>
        <AccessControlButton
          code={PM_ADD_CONFIG_GROUP_CODE}
          variant="contained"
          color="primary"
          size="small"
          onClick={handleOpenCreateDialog}
        >
          New Configuration Group
        </AccessControlButton>
        <div style={{ paddingLeft: "8px" }}>
          <b>Data as at </b>: {convertDateTimeToString(requestDateTime)}
        </div>
      </GridToolbarContainer>
    );
  }

  const handleOpenCreateDialog = () => {
    setSelectedFeatureIds([]);
    setOpenEditDialog(true);
  };

  const handleDuplicateFunctionClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    var _updateConfigurationGroup = configurationGroupManagementList.find(
      (f) => f.id === parseInt(event.currentTarget.value)
    );

    setAddConfigurationGroup(_updateConfigurationGroup);
    setOpenEditDialog(true);
  };

  const handleOpenEditDialog = (event: React.MouseEvent<HTMLButtonElement>) => {
    var _updateConfigurationGroup = configurationGroupManagementList.find(
      (f) => f.id === parseInt(event.currentTarget.value)
    );

    if (_updateConfigurationGroup !== undefined) {
      var _featureIds = _updateConfigurationGroup.configurations.map(
        (x) => x.id
      );

      //fill up featureIds for update later.
      setSelectedFeatureIds(_featureIds);

      //fill up for selector and to store existing features
      _updateConfigurationGroup.configurations.forEach((config) => {
        const _feature = featureList.find((f) => f.id === config.featureId);

        config.feature = _feature;
      });

      setEditConfigurationGroup({ ..._updateConfigurationGroup });
      setOpenEditDialog(true);
    }
  };

  const handleOpenDeleteDialog = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    var _removeConfigurationGroup = configurationGroupManagementList.find(
      (f) => f.id === parseInt(event.currentTarget.value)
    );
    setRemoveConfigurationGroup(_removeConfigurationGroup);
    setOpenDeleteDialog(true);
  };

  const handleEditOrAdd = () => {
    if (editConfigurationGroup == null) {
      if (
        addConfigurationGroup === null ||
        addConfigurationGroup.name === null ||
        addConfigurationGroup.name === ""
      ) {
        alert(
          "Please fill up the details below to add a new Configuration Group."
        );
      } else {
        createConfigurationGroupAPI({
          name: addConfigurationGroup.name,
          featureIds: selectedFeatureIds,
        })
          .then((response) => {
            if (response.resultCode == ARIA_SuccessCode) {
              setloadList(true);
              handleEditClose();
            } else {
              alert(response.resultDescription);
            }
          })
          .catch((err) => {
            alert(err);
          });
      }
    } else {
      if (
        editConfigurationGroup.name === null ||
        editConfigurationGroup.name === ""
      ) {
        alert("Please fill up the details below to edit configuration group.");
      } else {
        updateConfigurationGroupAPI({
          id: editConfigurationGroup.id,
          name: editConfigurationGroup.name,
          featureIds: selectedFeatureIds,
        })
          .then((response) => {
            if (response.resultCode == ARIA_SuccessCode) {
              setloadList(true);
              handleEditClose();
            } else {
              alert(response.resultDescription);
            }
          })
          .catch((err) => {
            alert(err);
          });
      }
    }
  };

  const handleDelete = () => {
    if (deleteConfirmation !== removeConfigurationGroup?.name) {
      alert("Please key in the configuration group name to confirm deletion.");
    } else {
      deleteConfigurationGroupAPI({ ...removeConfigurationGroup })
        .catch((err) => {
          alert(err);
        })
        .finally(() => {
          setDeleteConfirmation("");
          setloadList(true);
          handleEditClose();
        });
    }
  };

  const handleEditClose = () => {
    setAddConfigurationGroup(undefined);
    setEditConfigurationGroup(undefined);
    setRemoveConfigurationGroup(undefined);
    setOpenEditDialog(false);
    setOpenDeleteDialog(false);
  };

  return (
    <>
      <MainDrawer title="Configuration Group Management">
        {/* Add and Edit Dialog */}
        <Dialog
          open={openEditDialog}
          onClose={handleEditClose}
          aria-labelledby="form-dialog-title"
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle id="form-dialog-title">
            {editConfigurationGroup != undefined
              ? "Edit Configuration Group"
              : "Add Configuration Group"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              {editConfigurationGroup != undefined
                ? "Change the detail below and save it to update configuration group details, ."
                : "Fill up the details below to add a new configuration group."}
            </DialogContentText>
            <form noValidate autoComplete="off">
              <div>
                <TextField
                  margin="dense"
                  id="name"
                  label="Configuration Group Name"
                  type="text"
                  value={
                    editConfigurationGroup != undefined
                      ? editConfigurationGroup.name
                      : addConfigurationGroup?.name != undefined
                      ? addConfigurationGroup?.name
                      : ""
                  }
                  onChange={(e) => {
                    editConfigurationGroup != undefined
                      ? setEditConfigurationGroup({
                          ...editConfigurationGroup,
                          name: e.currentTarget.value,
                        })
                      : setAddConfigurationGroup({
                          ...addConfigurationGroup,
                          name: e.currentTarget.value,
                        });
                  }}
                  fullWidth
                />
                <FeatureSelector
                  value={
                    editConfigurationGroup != undefined
                      ? editConfigurationGroup.configurations.map((h) => {
                          if (h != null && h.feature != undefined)
                            return h.feature.name;

                          return "";
                        })
                      : addConfigurationGroup?.configurations
                          ?.map((h: { name: string }) => h.name)
                          .join(",")
                  }
                  onChange={(features) => {
                    var _selectedFeatureIdList: number[] = [];

                    const _selectedId = features.split(",");

                    _selectedId.forEach((name) => {
                      var _feature = featureList.find(
                        (feature) => feature.name === name
                      );
                      if (_feature !== undefined) {
                        _selectedFeatureIdList.push(_feature.id);
                      }
                    });

                    setSelectedFeatureIds(_selectedFeatureIdList);
                  }}
                />
              </div>
            </form>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleEditClose} color="primary">
              Cancel
            </Button>
            <Button onClick={handleEditOrAdd} color="primary">
              {editConfigurationGroup != null
                ? `Save & Update`
                : `Add Configuration Group`}
            </Button>
          </DialogActions>
        </Dialog>

        {/* delete Dialog */}
        {removeConfigurationGroup != undefined ? (
          <Dialog
            open={openDeleteDialog}
            onClose={handleEditClose}
            aria-labelledby="form-dialog-title"
            fullWidth
            maxWidth="sm"
          >
            <DialogTitle id="form-dialog-title">
              Delete Configuration Group
            </DialogTitle>
            <DialogContent>
              <form noValidate autoComplete="off">
                <div>
                  <TextField
                    margin="dense"
                    id="name"
                    label="Configuration Group Name"
                    type="text"
                    disabled
                    value={removeConfigurationGroup.name}
                    fullWidth
                  />
                  <DialogContentText
                    color="textPrimary"
                    style={{ marginTop: "18px" }}
                  >
                    {`Are you sure you want to delete ${removeConfigurationGroup.name}?`}
                  </DialogContentText>
                  <DialogContentText>
                    Please type the following to confirm:
                  </DialogContentText>
                  <DialogContentText>
                    <i>
                      <b>{removeConfigurationGroup.name}</b>
                    </i>
                  </DialogContentText>
                  <TextField
                    margin="dense"
                    variant="outlined"
                    id="name"
                    type="text"
                    value={deleteConfirmation}
                    onChange={(e) =>
                      setDeleteConfirmation(e.currentTarget.value)
                    }
                    fullWidth
                  />
                </div>
              </form>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleEditClose} color="primary">
                Cancel
              </Button>
              <Button onClick={handleDelete} color="primary">
                {`Delete`}
              </Button>
            </DialogActions>
          </Dialog>
        ) : null}

        {/* Data Grid */}
        <div style={{ height: "80vh" }}>
          <div style={{ display: "flex", height: "100%" }}>
            <div style={{ flexGrow: 1 }}>
              <DataGrid
                pageSize={size}
                rowsPerPageOptions={[10, 20, 30]}
                onPageSizeChange={(size) => {
                  setSize(size);
                  setloadList(true);
                }}
                disableColumnMenu
                density="compact"
                components={{
                  LoadingOverlay: CustomLoadingOverlay,
                  NoRowsOverlay: CustomNoRowsOverlay,
                  Toolbar: CustomToolbar,
                }}
                pagination
                loading={isLoading}
                paginationMode="server"
                rowCount={row}
                filterMode="server"
                onPageChange={(newPage) => {
                  setIndex(++newPage);
                  setloadList(true);
                }}
                rows={configurationGroupManagementList}
                columns={headerColumn}
                getRowId={(row) => row.id}
              />
            </div>
          </div>
        </div>
      </MainDrawer>
    </>
  );
};
